import React from 'react';

interface BTCIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

export const BTCIcon: React.FC<BTCIconProps> = ({
  width = 32,
  height = 32,
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="16" cy="16" r="16" fill="#F7931A" />
      <path
        d="M22.2822 11.8177C22.0388 9.67879 20.1768 8.99284 17.8382 8.82902L17.7863 5.8572L15.9774 5.88897L16.028 8.78246C15.5524 8.79082 15.0665 8.8087 14.5837 8.82677L14.5332 5.91411L12.7252 5.94562L12.7764 8.9166C12.3849 8.93143 12.0004 8.94542 11.6254 8.95222L11.625 8.943L9.13004 8.9857L9.16423 10.9177C9.16423 10.9177 10.4996 10.8689 10.4778 10.8939C11.2106 10.8813 11.4564 11.3025 11.5322 11.6684L11.5915 15.0539C11.642 15.0533 11.708 15.0542 11.7829 15.0632C11.7226 15.0643 11.6581 15.065 11.5918 15.0668L11.6741 19.8096C11.646 20.0407 11.5169 20.4107 11.005 20.4206C11.0285 20.4407 9.69003 20.4432 9.69003 20.4432L9.36832 22.6098L11.7224 22.5686C12.1605 22.5615 12.5916 22.5614 13.0148 22.5567L13.0681 25.5623L14.875 25.5311L14.8231 22.5572C15.3194 22.5588 15.7996 22.5543 16.2684 22.5457L16.3192 25.5059L18.1282 25.4741L18.0764 22.4738C21.1145 22.2462 23.2296 21.4429 23.4441 18.5825C23.6174 16.2791 22.5177 15.2719 20.7841 14.8875C21.8236 14.3351 22.4629 13.3827 22.2822 11.8177ZM19.8636 18.2887C19.9038 20.5348 16.0533 20.3464 14.8274 20.369L14.7583 16.3867C15.9846 16.3656 19.8228 15.9459 19.8636 18.2887ZM18.9242 12.6848C18.9593 14.7284 15.7476 14.5459 14.7265 14.5638L14.6635 10.952C15.6847 10.9341 18.8867 10.5534 18.9242 12.6848Z"
        fill="white"
      />
    </svg>
  );
};

export default BTCIcon;
